import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

export const ADD_STYLIST_REQUEST = 'ADD_STYLIST_REQUEST';
export const ADD_STYLIST_SUCCESS = 'ADD_STYLIST_SUCCESS';
export const ADD_STYLIST_FAILURE = 'ADD_STYLIST_FAILURE';
export const GET_STYLISTS_REQUEST = 'GET_STYLISTS_REQUEST';
export const GET_STYLISTS_SUCCESS = 'GET_STYLISTS_SUCCESS';
export const GET_STYLISTS_FAILURE = 'GET_STYLISTS_FAILURE';
export const GET_STYLIST_REQUEST = 'GET_STYLIST_REQUEST';
export const GET_STYLIST_SUCCESS = 'GET_STYLIST_SUCCESS';
export const GET_STYLIST_FAILURE = 'GET_STYLIST_FAILURE';
export const EDIT_STYLIST_REQUEST = 'EDIT_STYLIST_REQUEST';
export const EDIT_STYLIST_SUCCESS = 'EDIT_STYLIST_SUCCESS';
export const EDIT_STYLIST_FAILURE = 'EDIT_STYLIST_FAILURE';
export const DELETE_STYLIST_REQUEST = 'DELETE_STYLIST_REQUEST';
export const DELETE_STYLIST_SUCCESS = 'DELETE_STYLIST_SUCCESS';
export const DELETE_STYLIST_FAILURE = 'DELETE_STYLIST_FAILURE';
export const POST_SERVICE_FOR_STYLIST_REQUEST = 'POST_SERVICE_FOR_STYLIST_REQUEST';
export const POST_SERVICE_FOR_STYLIST_SUCCESS = 'POST_SERVICE_FOR_STYLIST_SUCCESS';
export const POST_SERVICE_FOR_STYLIST_FAILURE = 'POST_SERVICE_FOR_STYLIST_FAILURE';
export const EDIT_SERVICE_FOR_STYLIST_REQUEST = 'EDIT_SERVICE_FOR_STYLIST_REQUEST';
export const EDIT_SERVICE_FOR_STYLIST_SUCCESS = 'EDIT_SERVICE_FOR_STYLIST_SUCCESS';
export const EDIT_SERVICE_FOR_STYLIST_FAILURE = 'EDIT_SERVICE_FOR_STYLIST_FAILURE';
export const DELETE_SERVICE_FOR_STYLIST_REQUEST = 'DELETE_SERVICE_FOR_STYLIST_REQUEST';
export const DELETE_SERVICE_FOR_STYLIST_SUCCESS = 'DELETE_SERVICE_FOR_STYLIST_SUCCESS';
export const DELETE_SERVICE_FOR_STYLIST_FAILURE = 'DELETE_SERVICE_FOR_STYLIST_FAILURE';
export const POST_CATEGORY_FOR_STYLIST_REQUEST = 'POST_CATEGORY_FOR_STYLIST_REQUEST';
export const POST_CATEGORY_FOR_STYLIST_SUCCESS = 'POST_CATEGORY_FOR_STYLIST_SUCCESS';
export const POST_CATEGORY_FOR_STYLIST_FAILURE = 'POST_CATEGORY_FOR_STYLIST_FAILURE';
export const EDIT_CATEGORY_FOR_STYLIST_REQUEST = 'EDIT_CATEGORY_FOR_STYLIST_REQUEST';
export const EDIT_CATEGORY_FOR_STYLIST_SUCCESS = 'EDIT_CATEGORY_FOR_STYLIST_SUCCESS';
export const EDIT_CATEGORY_FOR_STYLIST_FAILURE = 'EDIT_CATEGORY_FOR_STYLIST_FAILURE';
export const DELETE_CATEGORY_FOR_STYLIST_REQUEST = 'DELETE_CATEGORY_FOR_STYLIST_REQUEST';
export const DELETE_CATEGORY_FOR_STYLIST_SUCCESS = 'DELETE_CATEGORY_FOR_STYLIST_SUCCESS';
export const DELETE_CATEGORY_FOR_STYLIST_FAILURE = 'DELETE_CATEGORY_FOR_STYLIST_FAILURE';

export const SET_STYLIST_SAVED = 'SET_STYLIST_SAVED';
export const RESET_STYLIST_SAVED = 'RESET_STYLIST_SAVED';
export const CLEAR_STYLIST_STATE = 'CLEAR_STYLIST_STATE';
export const REMOVE_SAVED_STYLISTS_IDS = 'REMOVE_SAVED_STYLISTS_IDS';
export const CLEAR_REQUEST_ERROR = 'CLEAR_REQUEST_ERROR';

export const UPDATE_ROLE_PRICE_REQUEST = 'UPDATE_ROLE_PRICE_REQUEST';
export const UPDATE_ROLE_PRICE_SUCCESS = 'UPDATE_ROLE_PRICE_SUCCESS';
export const UPDATE_ROLE_PRICE_FAILURE = 'UPDATE_ROLE_PRICE_FAILURE';
export const ENABLE_REMOTE_LOGIN_REQUEST = 'ENABLE_REMOTE_LOGIN_REQUEST';
export const ENABLE_REMOTE_LOGIN_SUCCESS = 'ENABLE_REMOTE_LOGIN_SUCCESS';
export const ENABLE_REMOTE_LOGIN_FAILURE = 'ENABLE_REMOTE_LOGIN_FAILURE';
export const DISABLE_REMOTE_LOGIN_REQUEST = 'DISABLE_REMOTE_LOGIN_REQUEST';
export const DISABLE_REMOTE_LOGIN_SUCCESS = 'DISABLE_REMOTE_LOGIN_SUCCESS';
export const DISABLE_REMOTE_LOGIN_FAILURE = 'DISABLE_REMOTE_LOGIN_FAILURE';

// FIXME: seems unused, delete it if it is
export const postCategoryDetailsForStylist = (execution, stylistId, salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/stylist/${stylistId}/categories/`,
    authenticated: true,
    types: [POST_CATEGORY_FOR_STYLIST_REQUEST, POST_CATEGORY_FOR_STYLIST_SUCCESS, POST_CATEGORY_FOR_STYLIST_FAILURE],
    config: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(execution),
    },
  },
});

// FIXME: seems unused, delete it if it is
export const putCategoryDetailsForStylist = (execution, stylistId, salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/stylist/${stylistId}/categories/`,
    authenticated: true,
    types: [EDIT_CATEGORY_FOR_STYLIST_REQUEST, EDIT_CATEGORY_FOR_STYLIST_SUCCESS, EDIT_CATEGORY_FOR_STYLIST_FAILURE],
    config: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(execution),
    },
  },
});

// FIXME: seems unused, delete it if it is
export const deleteCategoryDetailsForStylist = (execution, stylistId, salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/stylist/${stylistId}/categories/`,
    authenticated: true,
    types: [DELETE_CATEGORY_FOR_STYLIST_REQUEST, DELETE_CATEGORY_FOR_STYLIST_SUCCESS, DELETE_CATEGORY_FOR_STYLIST_FAILURE],
    config: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ category: execution.category }),
    },
  },
});

export const removeSavedStylistsIds = (idsToRemove) => ({
  type: REMOVE_SAVED_STYLISTS_IDS,
  idsToRemove,
  meta: { analytics: EventTypes.track },
});

export const setStylistSaved = () => ({ type: SET_STYLIST_SAVED, meta: { analytics: EventTypes.track } });
export const resetStylistSaved = () => ({ type: RESET_STYLIST_SAVED, meta: { analytics: EventTypes.track } });
export const clearStylistState = () => ({ type: CLEAR_STYLIST_STATE, meta: { analytics: EventTypes.track } });
export const clearRequestError = () => ({ type: CLEAR_REQUEST_ERROR, meta: { analytics: EventTypes.track } });

export const updateRolePrice = (stylistId, stylistRoleId, salonId, previousRoleId, updateAll) => {
  const data = { previous_role_id: previousRoleId, new_role_id: stylistRoleId, updateAll };

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/stylist/${stylistId}/update/prices/asrole/`,
      authenticated: true,
      types: [UPDATE_ROLE_PRICE_REQUEST, UPDATE_ROLE_PRICE_SUCCESS, UPDATE_ROLE_PRICE_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
    },
  };
};
